import React, { FC, MouseEvent, ReactNode } from 'react';
import styled from 'styled-components';
import { TranslationHelpers } from '../../../i18n/translationHelpers';

import { COLORS } from '../../../app/common/constants/styles';

const DataUsageBlock = styled.div`
    display: flex;
`;

const ConsentWrapper = styled.div`
    overflow-y: hidden;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition: height 2s;
    margin-right: 2rem;
`;

export const CheckPrivacySettingsLink = styled.a`
    color: ${COLORS.rakutenRed};
    display: block;
    font-size: 13px;
    line-height: 1.5;
    cursor: pointer;
    transition: font-weight 200ms ease-in;
    text-decoration: none;
    &:hover {
        font-weight: bold;
    }
    margin-bottom: 1rem;
`;

const SwitchButtonContainer = styled.div`
    width: 100%;
`;

type ExternalClickData = {
    page: string;
    destination: string;
};

export type ConsentBlockProps = {
    mandatoryConsents?: ReactNode[];
    optionalConsents: any;
    privacySettingsLink: string;
    onExternalTrackingClick(event: MouseEvent, data: ExternalClickData): void;
    anyServiceCmpIntegrated: boolean;
    showOptionalConsent: boolean;
};

const ConsentsBlock: FC<ConsentBlockProps> = (props) => {
    const {
        mandatoryConsents,
        optionalConsents,
        privacySettingsLink,
        onExternalTrackingClick,
        anyServiceCmpIntegrated,
        showOptionalConsent,
    } = props;

    return (
        <DataUsageBlock data-qa-id="ucrm-consent-block">
            <SwitchButtonContainer>
                <ConsentWrapper>
                    {mandatoryConsents}
                    {showOptionalConsent && optionalConsents}
                    {privacySettingsLink && anyServiceCmpIntegrated && (
                        <CheckPrivacySettingsLink
                            href={privacySettingsLink}
                            onClick={(e) =>
                                onExternalTrackingClick(e, {
                                    page: 'Privacy',
                                    destination: privacySettingsLink,
                                })
                            }
                        >
                            {TranslationHelpers.getFormattedMessage(
                                'privacy.check_specific_privacy_settings',
                            )}
                        </CheckPrivacySettingsLink>
                    )}
                </ConsentWrapper>
            </SwitchButtonContainer>
        </DataUsageBlock>
    );
};

export default ConsentsBlock;
